import { render, staticRenderFns } from "./ProjectImgGallery_comp.vue?vue&type=template&id=9db16484&scoped=true&"
import script from "./ProjectImgGallery_comp.vue?vue&type=script&lang=js&"
export * from "./ProjectImgGallery_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImgGallery_comp.vue?vue&type=style&index=0&id=9db16484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db16484",
  null
  
)

export default component.exports